<template lang="html">

  <section class="header">

    <div class="container row-between">

      <h1>
        <router-link to="/"><img width="143px" src="/static/img/logo.png" alt="Logo"></router-link>
      </h1>

      <nav class="row-start" :show="show">

        <button class="cerrar-menu" @click="show= false">✕</button>

        <div class="menu">

          <a class="inicio" to="inicio">{{$t('menu.inicio')}}</a>
          <a to="situacion">{{$t('menu.situacionactual')}}</a>
          <a to="que-es">{{$t('menu.quees')}}</a>
          <a to="que-ofrece">{{$t('menu.queofrece')}}</a>
          <a to="ventajas">{{$t('menu.ventajas')}}</a>
          <a to="caracteristicas">{{$t('menu.caracteristicas')}}</a>
          <a to="como-funciona">{{$t('menu.comofunciona')}}</a>
          <a to="contacto">{{$t('menu.contacto')}}</a>

        </div>
      </nav>

      <button class="show-menu" @click="show= true">
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'app-header',
    data() {
      return {
          show : false
      }
    },
    mounted() {

      this.setMenuAnimacion();

      var that = this;

      $(window).scroll(function(event) {
          that.setMenuAnimacion();
      });


      $(".menu a").click(function(event) {
        let to = $(this).attr("to");

        that.show = false;
      
        $('html, body').animate({
          scrollTop: $("#"+to).offset().top - 80
        }, 800);
      })

    },
    methods : {
      setMenuAnimacion : function(){
        let altura = $(window).scrollTop();
        if(altura > 400){
          $(".header").addClass('rar');
        }else if($(".header").hasClass('rar')){
          $(".header").removeClass('rar');
        }
      }
    },
    watch : {
      '$route' : function(){
        this.show = false;
      }
    }
  }
</script>

<style scoped>

.header {
  padding: 10px 0;
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  z-index: 20;
  background: #f3f7fb;
  transition: .5s;
  border-bottom: 1px solid #f5f8fb;
}

.header.rar{
  background: #e1eaf2;
  border-bottom: 1px solid #bed2e5;
  padding: 5px 0;
}

.header h1 a{
  display: grid;
}

.header img{
  transition: .5s;
}

.header.rar img{
  max-height: 70px;
  transform: scale(.7);
}

.header .btn-rounded-blue{
  transition: .5s;
}

.header.rar .btn-rounded-blue{
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  font-size: 16px;
}


.menu a{
  font-size: 16px;
  padding: 10px;
  color: #3374b0;
  font-family: 'Ubuntu Mono', sans-serif;
  overflow: hidden;
  position: relative;
  display: inline-block;
}


.menu a::before{
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 15px;
  width: 50px;
  display: inline-block;
  background: #3374b0;
  opacity: .2;
  content: '';
  transition: .7s;
  animation-timing-function: ease-in-out;
  transform: translateX(-110%);
}

.menu a.router-link-exact-active,
.menu a.router-link-active:not(.inicio){
  font-weight: 600;
  color: #41566d;
}

.menu a.router-link-exact-active::before,
.menu a.router-link-active:not(.inicio)::before{
  transform: translateX(0);
}
.btn-rounded-blue{
  margin-left: 20px;
}

.cerrar-menu{
  display: none;
}

.show-menu{
  display: none;
}

@media screen and (max-width: 1100px){
  
  nav{
    position: fixed;
    left: 0;
    top: -120vh;
    height: 100vh;
    width: 100%;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    background: white;
    padding: 30px 20px;
       transition: .7s transform cubic-bezier(0.785, 0.135, 0.15, 0.86);
       z-index: 4;
       box-shadow: 1px 3px 50px 5px rgba(117, 117, 117, 0.5);
  }

  nav[show="true"]{
    transform: translateY(120vh);
  }

  nav .menu {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    margin-bottom: 3vh;
  }

  nav .menu a{
    font-size: 6vw;
  }

  .btn-rounded-blue,
  .header.rar .btn-rounded-blue{
    font-size: 5vw;
    height: auto;
    padding: 2.5vw 7vw;
    margin-left: 0;
  }

  .menu a::before{
    height: 4vw;
    width: 15vw;
    left: -3vw;
  }

  .cerrar-menu{
    font-size: 30px;
    color: #3374b0;
    position: absolute;
    right: 20px;
    top: -200px;
    background: none;
    border: none;
    outline: none;
    display: inline-block;
    transition: .7s transform cubic-bezier(0.785, 0.135, 0.15, 0.86);
  }

  nav[show=true] .cerrar-menu{
    transform: translateY(220px);
  }

  .show-menu{
    width: 40px;
    height: 18px;
    background:none;
    display: inline-block;
    position: relative;
    border: none;
    outline: none;
  }

  .show-menu span{
    width: 40px;
    height: 2px;
    background: #3374b0;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
  }

  .show-menu span:nth-child(2n){
    top: 50%;
    margin-top: -1px;
  }

  .show-menu span:last-of-type{
    top: auto;
    bottom: 0;
  }
  
}

@media screen and (max-width: 600px){
  
  .header{
    padding: 15px 0;
    width: 100vw;
  }

  .header.rar{
    padding: 15px 0;
  }

  .header .container{
    padding: 0 10px;
  }

  .header img{
    max-width: 80px;
  }

  .header.rar img{
    transform: scale(1);
  }

    .btn-rounded-blue,
  .header.rar .btn-rounded-blue{
    padding: .5vw 7vw;
    font-size: 20px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/parts/header.vue